import React, { useState } from "react";
import { 
  Shield, Fuel, Wrench, Monitor, Leaf, TrendingUp,
  ChevronRight, ArrowLeft, Check, Phone, Mail
} from "lucide-react";

// Logo MOBILSAFE 
const MOBILSAFE_LOGO = "/logo-mobilsafe.png";

const MockupFondoBlanco = () => {
  const [vista, setVista] = useState('selector'); // 'selector', 'landing', 'caes'

  // Selector de mockups
  if (vista === 'selector') {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center p-8">
        <div className="max-w-2xl w-full">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-black text-white mb-4">MOCKUP - Fondo Blanco</h1>
            <p className="text-slate-400">Selecciona qué página quieres ver con fondo blanco</p>
            <p className="text-amber-400 text-sm mt-2">Esto es solo una simulación, no afecta al código real</p>
          </div>
          
          <div className="grid gap-6">
            <button
              onClick={() => setVista('landing')}
              className="p-6 bg-white/10 hover:bg-white/20 border border-white/20 rounded-2xl text-left transition-all group"
            >
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-emerald-400">Landing Principal (Simulador)</h3>
              <p className="text-slate-400">Ver el simulador de ahorros con fondo blanco</p>
            </button>
            
            <button
              onClick={() => setVista('caes')}
              className="p-6 bg-white/10 hover:bg-white/20 border border-white/20 rounded-2xl text-left transition-all group"
            >
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-400">Landing CAES</h3>
              <p className="text-slate-400">Ver Tu Ingreso CAES con fondo blanco</p>
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Mockup Landing Principal con fondo blanco
  if (vista === 'landing') {
    return (
      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
          <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <img src={MOBILSAFE_LOGO} alt="MOBILSAFE" className="h-8" />
              <span className="text-slate-500 text-sm font-medium">FLEET TECHNOLOGY</span>
            </div>
            <button className="px-6 py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full font-bold text-sm">
              TU INGRESO CAES
            </button>
          </div>
        </header>

        {/* Hero */}
        <section className="py-20 px-6">
          <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                SIMULADOR DE IMPACTO SOSTENIBLE
              </div>
              <h1 className="text-4xl lg:text-5xl font-black text-slate-900 mb-6 leading-tight">
                REDUCE COSTES Y{" "}
                <span className="text-emerald-500">EMISIONES CO₂</span>
              </h1>
              <p className="text-lg text-slate-600 mb-8">
                Calcula en segundos el impacto sostenible de MOBILSAFE en tu flota. 
                Ahorro de combustible, reducción de emisiones y certificados CAES monetizables.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-emerald-500/30">
                  COMENZAR SIMULACIÓN <ChevronRight className="w-5 h-5" />
                </button>
                <button className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg shadow-orange-500/30">
                  TU INGRESO CAES <ChevronRight className="w-5 h-5" />
                </button>
              </div>
              
              {/* Stats */}
              <div className="flex gap-8 mt-12">
                <div>
                  <div className="text-3xl font-black text-emerald-500">+500</div>
                  <div className="text-sm text-slate-500">FLOTAS ANALIZADAS</div>
                </div>
                <div>
                  <div className="text-3xl font-black text-emerald-500">45K</div>
                  <div className="text-sm text-slate-500">TON CO₂ EVITADAS</div>
                </div>
                <div>
                  <div className="text-3xl font-black text-emerald-500">12M€</div>
                  <div className="text-sm text-slate-500">AHORROS GENERADOS</div>
                </div>
              </div>
            </div>

            {/* Áreas */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Shield, name: "SEGURIDAD", desc: "Reduce accidentes y riesgo", color: "red" },
                { icon: Fuel, name: "COMBUSTIBLE", desc: "Hasta 8% menos consumo", color: "blue" },
                { icon: Monitor, name: "OPERATIVA", desc: "Cumple plazos y descubre improductividades", color: "purple" },
                { icon: Wrench, name: "MANTENIMIENTO", desc: "Anticipa averías", color: "amber" },
                { icon: TrendingUp, name: "TIC / DATOS", desc: "Integra fácil", color: "cyan" },
                { icon: Leaf, name: "SOSTENIBILIDAD", desc: "Reduce CO₂ e ingresa dinero", color: "green" },
              ].map((area, i) => (
                <div 
                  key={i} 
                  className="p-5 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl cursor-pointer transition-all hover:shadow-lg group"
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-3 ${
                    area.color === 'red' ? 'bg-red-100 text-red-500' :
                    area.color === 'blue' ? 'bg-blue-100 text-blue-500' :
                    area.color === 'purple' ? 'bg-purple-100 text-purple-500' :
                    area.color === 'amber' ? 'bg-amber-100 text-amber-500' :
                    area.color === 'cyan' ? 'bg-cyan-100 text-cyan-500' :
                    'bg-green-100 text-green-500'
                  }`}>
                    <area.icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-bold text-slate-800 text-sm">{area.name}</h3>
                  <p className="text-xs text-slate-500 mt-1">{area.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="py-8 bg-slate-100 border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <img src={MOBILSAFE_LOGO} alt="MOBILSAFE" className="h-8 mx-auto mb-4 opacity-60" />
            <p className="text-slate-500 text-sm">© 2026 MOBILSAFE Fleet Technology</p>
          </div>
        </footer>

        {/* Botón volver */}
        <button
          onClick={() => setVista('selector')}
          className="fixed bottom-6 left-6 px-4 py-3 bg-slate-900 text-white rounded-full shadow-xl flex items-center gap-2 hover:bg-slate-800"
        >
          <ArrowLeft className="w-5 h-5" /> Volver al selector
        </button>
      </div>
    );
  }

  // Mockup Landing CAES con fondo blanco
  if (vista === 'caes') {
    return (
      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
          <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
            <button className="flex items-center gap-3 text-slate-600 hover:text-slate-900">
              <ArrowLeft className="w-5 h-5 text-emerald-500" />
              <span className="font-medium">CALCULA MÁS AHORROS CON</span>
              <img src={MOBILSAFE_LOGO} alt="MOBILSAFE" className="h-6" />
            </button>
            <button className="px-6 py-2 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full font-bold text-sm">
              TU INGRESO CAES
            </button>
          </div>
        </header>

        {/* Hero CAES */}
        <section className="py-20 px-6 bg-gradient-to-br from-orange-50 to-red-50">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-bold mb-6">
              CERTIFICADOS DE AHORRO ENERGÉTICO
            </div>
            <h1 className="text-4xl lg:text-5xl font-black text-slate-900 mb-6 leading-tight">
              Tu flota tiene{" "}
              <span className="text-orange-500">dinero dormido</span>
            </h1>
            <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
              Descubre cuánto puedes ganar con los Certificados de Ahorro Energético (CAES) 
              gracias a la conducción eficiente de tu flota.
            </p>
            <button className="px-10 py-5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl font-bold text-lg shadow-xl shadow-orange-500/30 flex items-center gap-3 mx-auto">
              CALCULAR MI INGRESO CAES <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </section>

        {/* Diferenciación */}
        <section className="py-16 px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-center text-slate-800 mb-12">
              ¿Por qué MOBILSAFE consigue <span className="text-orange-500">+50% más</span>?
            </h2>
            
            <div className="grid md:grid-cols-3 gap-6">
              {[
                { 
                  title: "No te dejamos solo",
                  desc: "90 días de acompañamiento real. Formación continua a conductores.",
                  icon: "🤝"
                },
                { 
                  title: "Expertos en TRA-020",
                  desc: "La ficha más difícil, pero la más rentable. Mejoramos tu conducción.",
                  icon: "📊"
                },
                { 
                  title: "Acuerdos exclusivos",
                  desc: "Negociamos con sujetos obligados para maximizar tu ingreso.",
                  icon: "🤝"
                }
              ].map((item, i) => (
                <div key={i} className="p-6 bg-slate-50 border border-slate-200 rounded-2xl text-center hover:shadow-lg transition-all">
                  <div className="text-4xl mb-4">{item.icon}</div>
                  <h3 className="font-bold text-slate-800 mb-2">{item.title}</h3>
                  <p className="text-sm text-slate-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16 px-6 bg-slate-900">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl font-bold text-white mb-4">
              ¿15 minutos para explicarte cómo lo hacemos?
            </h2>
            <p className="text-slate-400 mb-8">
              Sin compromiso. Te contamos nuestra metodología.
            </p>
            <button className="px-10 py-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl font-bold text-lg shadow-xl">
              QUIERO MI REUNIÓN GRATUITA
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="py-8 bg-white border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <img src={MOBILSAFE_LOGO} alt="MOBILSAFE" className="h-8 mx-auto mb-4 opacity-60" />
            <p className="text-slate-500 text-sm">© 2026 MOBILSAFE Fleet Technology</p>
          </div>
        </footer>

        {/* Botón volver */}
        <button
          onClick={() => setVista('selector')}
          className="fixed bottom-6 left-6 px-4 py-3 bg-slate-900 text-white rounded-full shadow-xl flex items-center gap-2 hover:bg-slate-800"
        >
          <ArrowLeft className="w-5 h-5" /> Volver al selector
        </button>
      </div>
    );
  }

  return null;
};

export default MockupFondoBlanco;
